export const environment = {
  production: true,
  serverUrl: 'https://uts-api.phxsmartuni.asia'
};
